"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackVisibility = exports.scrollTo = void 0;
var all_1 = require("../external/gsap/umd/all");
all_1.gsap.registerPlugin(all_1.ScrollTrigger, all_1.ScrollToPlugin, all_1.SplitText);
// Store gsap against the Window object.
window.gsap = all_1.gsap;
var initialiseGsapEntryAnimations = function () {
    var entryElements = Array.from(document.querySelectorAll('.entry'));
    if (!entryElements.length)
        return;
    entryElements.forEach(function (element) {
        all_1.gsap.to(element, {
            scrollTrigger: {
                start: 'top bottom',
                trigger: element,
                toggleClass: 'entry-active',
                once: true,
            },
        });
    });
};
var initialiseAdvancedEntryAnimations = function () {
    var entryElements = Array.from(document.querySelectorAll('.entry-line-by-line'));
    if (!entryElements.length)
        return;
    entryElements.forEach(function (element) {
        var paragraphLines = new all_1.SplitText(element, { type: 'lines' });
        all_1.gsap.set(paragraphLines.lines, { opacity: 0, y: '+=50' });
        all_1.gsap.to(element, {
            scrollTrigger: {
                start: 'top 90%',
                trigger: element,
                once: true,
                onEnter: function () {
                    all_1.gsap.to(paragraphLines.lines, {
                        duration: 1.2,
                        stagger: 0.15,
                        autoAlpha: 1,
                        y: 0,
                        ease: 'power2',
                        onComplete: function () {
                            // When the animated is completed, revert to the original text so that it can flow within its
                            // container naturally.
                            // @ts-ignore it says this isn't a valid function, it definitely is according to GSAP docs.
                            paragraphLines.revert();
                        },
                    });
                },
            },
        });
    });
};
// Utility method to scroll-smooth to any element.
var scrollTo = function (el, offset) {
    if (offset === void 0) { offset = 0; }
    all_1.gsap.to(window, {
        duration: 1.5,
        ease: 'power2',
        scrollTo: {
            y: el,
            offsetY: offset,
        },
    });
};
exports.scrollTo = scrollTo;
// Utility method to be used for tracking visibility of modules.
var trackVisibility = function (element, cb) {
    all_1.gsap.to(element, {
        scrollTrigger: {
            start: 'top bottom',
            trigger: element,
            once: true,
            onEnter: function () {
                if (typeof cb === 'function') {
                    cb();
                }
            },
        },
    });
};
exports.trackVisibility = trackVisibility;
document.addEventListener('alpine:init', function () {
    initialiseGsapEntryAnimations();
    initialiseAdvancedEntryAnimations();
});
